import { I18n } from 'react-redux-i18n'
import { isValidNif } from 'utils/helpers'

export default (company) => {
  const errors = {}

  const requiredFields = ['legalName', 'nif', 'address', 'postalCode', 'city', 'province', 'country', 'primaryPhone', 'billingEmail']

  requiredFields.forEach((field) => {
    if (!company[field]) errors[field] = I18n.t('dashboard_errors_required-field')

    if (field === 'nif') {
      if (!isValidNif(company.nif)) errors[field] = I18n.t('dashboard_errors_not-valid-nif')
    }
  })

  return errors
}
